module.exports = __webpack_public_path__ + "img/emaster-logo.8f6898b0.png";